export default "__VITE_ASSET__BxYVZfIN__"